import templateUrl from './attributeRow.html'

/**
 * @type {ngComponent}
 */
export const tmrOperationConfigurationFormAttributeRow = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrOperationConfigurationFormAttributeRowController',
  bindings: {
    key: '@',
    keyLabel: '@',
    options: '<?',
    resource: '=',
    allowCustomValue: '<?',
    requiredCustomValueInput: '<?',
    onDelete: '&?',
  },
}

/**
 * @type {ngController}
 */
export class tmrOperationConfigurationFormAttributeRowController {
  static ngType = 'controller'

  constructor($element, $window, $mdDialog) {
    'ngInject'
    Object.assign(this, { $element, $window, $mdDialog })
  }

  $onInit() {
    this.$element.addClass('tmr-tr')
    this.requiredCustomValueInput = this.requiredCustomValueInput ?? true
  }

  dialog(targetEvent) {
    if (
      this.options &&
      Object.keys(this.options).includes(this.resource.attributes[this.key])
    ) {
      this.value = this.resource.attributes[this.key]
    } else {
      this.value = '_custom'
      this.customValue = this.resource.attributes[this.key]
    }

    this.$mdDialog
      .show({
        contentElement: `#dialog-${this.$window.CSS.escape(this.key)}`,
        targetEvent,
      })
      .then(
        op => this.onDialogClose(op),
        () => this.onDialogClose()
      )
  }

  onKeyPress($event) {
    if ($event.key == 'Enter' && this.form.$valid)
      this.$mdDialog.hide('confirm')
  }

  onDialogClose(op) {
    if (op === 'confirm') {
      this.resource.attributes[this.key] =
        this.value === '_custom' ? this.customValue : this.value
    } else {
      if (
        this.onDelete &&
        this.value === '_custom' &&
        !this.resource.attributes[this.key]
      )
        this.onDelete()
      else this.value = this.resource.attributes[this.key]
    }
  }

  showKey(key) {
    return (
      !['yes', 'no', 'true', 'false'].includes(key) ||
      (this.resource.attributes[this.key] !== undefined &&
        !this.options[this.resource.attributes[this.key]])
    )
  }
}
